export type JobType = 'full-time' | 'part-time' | 'contract' | 'internship';

export interface JobPosition {
  id: string;
  title: string;
  department: string;
  location: string;
  type: JobType;
  description: string;
  requirements: string[];
  isActive: boolean;
  postedAt: string;
}

export const mockJobPositions: JobPosition[] = [
  {
    id: 'job-001',
    title: 'Senior Management Consultant',
    department: 'Management Consultancy',
    location: 'Ankara, Turkey',
    type: 'full-time',
    description:
      'We are looking for an experienced Senior Management Consultant to join our growing team. You will lead complex project engagements, mentor junior consultants, and contribute to business development activities across our core practice areas.',
    requirements: [
      'Minimum 7 years of management consulting experience',
      'Proven track record in public sector or development projects',
      'Strong analytical and communication skills in English and Turkish',
      'CMC certification or equivalent is a plus',
      'Willingness to travel domestically and internationally',
    ],
    isActive: true,
    postedAt: '2026-03-01',
  },
  {
    id: 'job-002',
    title: 'Policy Development Specialist',
    department: 'Policy & Research',
    location: 'Ankara, Turkey',
    type: 'full-time',
    description:
      'Join our Policy & Research team to deliver high-quality policy analysis and development projects for international organisations, government agencies, and development banks. You will lead and contribute to policy design, stakeholder engagement, and report production.',
    requirements: [
      'Master\'s degree in public policy, economics, or related field',
      'At least 4 years of relevant policy work experience',
      'Experience working with EU institutions or IFIs is highly desirable',
      'Excellent written and verbal communication in English',
      'Knowledge of EU cohesion or regional development policy is an advantage',
    ],
    isActive: true,
    postedAt: '2026-03-10',
  },
];
